import { ERROR_MESSAGE, LOADED, LOADING, RESET_MESSAGES, SUCCESS_MESSAGE, VALIDATION_AUTH_ERROR, VALIDATION_ERROR } from "../actions/types";

const initState = {
    validationError: null,
    validationAuthError: null,
    error: null,
    success: null,
    loading: false,
}
export default (state = initState , action) => {
    switch (action.type) {
 
        case ERROR_MESSAGE:
            return{
                ...state, 
                error: action.payload,
            };
        case SUCCESS_MESSAGE:
            return{
                ...state, 
                success: action.payload,
            };
        case LOADING:
            return{
                ...state, 
                loading: true,
            };
        case LOADED:
            return{
                ...state, 
                loading: false,
            };
        case RESET_MESSAGES:
            return {
                ...state,
                error: null,
                success: null,
            }
        case VALIDATION_ERROR:
            return {
                ...state,
                validationError: action.payload,
            }
        case VALIDATION_AUTH_ERROR:
            return {
                ...state,
                validationAuthError: action.payload,
            }
        
            default:
                return state;
        }
    }